<template>
    <div class="course-dates">
        <div class="course-dates__item -highlight" v-if="lastUpdatedDate">
            <span class="icon-calendar-check"></span>
            <span class="course-dates__label" v-html="$t('CourseDates.last_updated')"></span>
            <span class="course-dates__description">{{ formattedDateForCountry(lastUpdatedDate) }}</span>
        </div>
        <div class="course-dates__item" v-if="publishedDate">
            <span class="icon-calendar-star"></span>
            <span class="course-dates__label" v-html="$t('CourseDates.publish_date')"></span>
            <span class="course-dates__description">{{ formattedDateForCountry(publishedDate) }}</span>
        </div>
        <div class="course-dates__item" v-if="expirationDate">
            <span class="icon-calendar-xmark"></span>
            <span class="course-dates__label" v-html="$t('CourseDates.expiration_date')"></span>
            <span class="course-dates__description">{{ formattedDateForCountry(expirationDate) }}</span>
        </div>
    </div>
</template>

<script>
    import { formattedDateForCountry } from 'components/shared/mixins/dateHelper'
    export default {
        props: {
            publishedDate: String,
            expirationDate: String,
            lastUpdatedDate: String
        },
        methods: { formattedDateForCountry }
    }
</script>

<style lang="scss" scoped>
    .course-dates {
        display: flex;
        position: relative;
        font-size: 1.6rem;
        margin: 10px 0 0 0;
        gap: 12px;

        &__item {
            display: flex;
            align-items: center;
            gap: 10px;
        }

        [class*="mobile_sm"] & {
            flex-direction: column;
        }
    }
</style>
